export default "__VITE_ASSET__3re8DJAI__"